module.exports = __webpack_public_path__ + "media/Margaux_Matterport_Outro.6dd61dcc.mp4";